import BaseApi from './baseApi';
import INoticeOfLossPictures from '../models/INoticeOfLossPictures';
import IAuthentication from '../models/IAuthentication';
export default class NoticeOfLossPicturesApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "NoticeOfLoss");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetInboundsNoticeOfLossPictures(noticeOfLossId: string) : Promise<INoticeOfLossPictures[]> {
        let json : string = this.getJsonRead(noticeOfLossId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inboundsNoticeOfLossPictures: INoticeOfLossPictures[] = [];
            inboundsNoticeOfLossPictures = response.data as INoticeOfLossPictures[];
            return inboundsNoticeOfLossPictures;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveInboundsNoticeOfLossPictures(inboundsNoticeOfLossPictures: INoticeOfLossPictures) : Promise<string> {
        const json = this.getJsonSave(inboundsNoticeOfLossPictures);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateNoticeOfLossPictures(inboundsNoticeOfLossPictures: INoticeOfLossPictures) : Promise<boolean> {
        const json = this.getJsonUpdate(inboundsNoticeOfLossPictures);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteNoticeOfLossPictures(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteNoticeOfLossPicturesByNoticeOfLossId(noticeOfLossId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByNoticeOfLossId(noticeOfLossId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsNoticeOfLossPictures",
            "conditions": [{
                "Item1": "InboundsNoticeOfLossPictures",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonDeleteByNoticeOfLossId(idNoticeOfLoss: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsNoticeOfLossPictures",
            "conditions": [{
                "Item1": "InboundsNoticeOfLossPictures",
                "Item2": "idNoticeOfLoss",
                "Item3": "=",
                "Item4": idNoticeOfLoss
            }]
        };
        return json;
    }

    private getJsonSave(inboundsNoticeOfLossPictures: INoticeOfLossPictures) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idNoticeOfLoss",
                "Item2": inboundsNoticeOfLossPictures.idNoticeOfLoss
            }, {
                "Item1": "url",
                "Item2": inboundsNoticeOfLossPictures.url
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "InboundsNoticeOfLossPictures"
        };
        return json;
    }

    private getJsonUpdate(inboundsNoticeOfLossPictures: INoticeOfLossPictures) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idNoticeOfLoss",
                "Item2": inboundsNoticeOfLossPictures.idNoticeOfLoss
            }, {
                "Item1": "url",
                "Item2": inboundsNoticeOfLossPictures.url
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "InboundsNoticeOfLossPictures",
            "keyvalue": inboundsNoticeOfLossPictures.id
        };
        return json;
    }

    private getJsonRead(idNoticeOfLoss: string) : any {
        const json = {
            "fields": [{
                "Item1": "InboundsNoticeOfLossPictures",
                "Item2": "id"
            }, {
                "Item1": "InboundsNoticeOfLossPictures",
                "Item2": "idNoticeOfLoss"
            }, {
                "Item1": "InboundsNoticeOfLossPictures",
                "Item2": "url"
            }],
            "tables": [{
                "Item1": "InboundsNoticeOfLossPictures"
            }],
            "conditions": [{
                "Item1": "InboundsNoticeOfLossPictures",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "InboundsNoticeOfLossPictures",
                "Item2": "idNoticeOfLoss",
                "Item3": "=",
                "Item4": idNoticeOfLoss
            }]
        };
        return json;
    }
}
